import React from "react";
import "./style.css";
import { Link } from "react-router-dom";

function Hero() {
  // Function to handle scroll to portfolio
  const scrollToPortfolio = () => {
    const portfolioSection = document.getElementById("portfolio-section");
    portfolioSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="hero">
      <div className="hero-contents">
        <div className="intro">
          <h1>
            Hey, I'm Nishan <span className="khanal">Khanal</span>
          </h1>
        </div>
        <div className="about">
          <p>
            A front-end web developer that is passionate about combining
            business and technology to create successful products.
          </p>
        </div>
        <div className="projects">
          {/* Projects Button */}
          <button
            className="project-in"
            onClick={scrollToPortfolio}
          >
            Projects
          </button>
          {/* CV Button */}
          <Link className="cv-button" to="/cv" rel="noopener noreferrer">View CV</Link>
        </div>
      </div>
    </div>
  );
}

export default Hero;
